import React from 'react';

import { FormSelect } from '../../../app/components/FormSelect';

interface SchoolCandidateSelectorProps {
  value?: boolean | null;
  onChange: (value: boolean) => void;
}

export const SchoolCandidateSelector: React.FC<
  SchoolCandidateSelectorProps
> = ({ value, onChange }) => {
  const toStringValue = () => {
    if (value === undefined || value === null) {
      return undefined;
    }
    return value ? 'true' : 'false';
  };

  return (
    <FormSelect
      value={toStringValue()}
      options={[
        { value: 'false', label: 'Uczeń' },
        { value: 'true', label: 'Kandydat na ucznia' },
      ]}
      onChange={v => onChange(v === 'true')}
    />
  );
};
